import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lang-select',
  templateUrl: './lang-select.component.html',
  styleUrls: ['./lang-select.component.scss']
})
export class LangSelectComponent implements AfterViewInit {
  @ViewChild('select') select: any;

  value = 'en';
  options = ['id', 'en', 'cn', 'jp'];
  showDropdown = false;

  constructor(private translate: TranslateService) { }

  ngAfterViewInit(): void {
    this.value = this.translate.currentLang;    
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  onChange(option: string) {
    this.value = option;
    this.showDropdown = false;
    this.translate.use(option);
  }

  onFocusOut() {
    setTimeout(() => {
      this.select.nativeElement.removeAttribute('open');
      this.showDropdown = false;
    }, 200);
  }
}
